import { ParsedUrlQuery } from 'querystring';

export function getSearchPath(query: ParsedUrlQuery) {
    if (query['search-path']) {
        // there is a bug in LSRP and perhaps Next itself where pushing to the router (and triggering GIP) causes the url params to appear as a path part in router.query['search-path'] i.e ['property', 'london', '?q=london']
        const searchPath = Array.isArray(query['search-path'])
            ? query['search-path']
            : [query['search-path']];
        const validSearchPath = searchPath.filter(
            (v) =>
                !v.startsWith('?') &&
                v !== '_static' &&
                v !== 'v1' &&
                v !== 'v2' &&
                !v.match(/\d+-bedroom/) &&
                !v.match(/studio/) // filters out path segments with [number]-bedroom pattern and studio see https://zpgltd.atlassian.net/browse/SR-2141
        );
        return validSearchPath;
    }

    return [];
}
